// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  EndpointsResponse,
  InternalModelsGet200Response,
  InternalModelsIdGet200Response,
  InternalSessionsGet200Response,
  InternalSessionsSessionIdGet200Response,
} from '../models/index';
import {
  EndpointsResponseFromJSON,
  EndpointsResponseToJSON,
  InternalModelsGet200ResponseFromJSON,
  InternalModelsGet200ResponseToJSON,
  InternalModelsIdGet200ResponseFromJSON,
  InternalModelsIdGet200ResponseToJSON,
  InternalSessionsGet200ResponseFromJSON,
  InternalSessionsGet200ResponseToJSON,
  InternalSessionsSessionIdGet200ResponseFromJSON,
  InternalSessionsSessionIdGet200ResponseToJSON,
} from '../models/index';

export interface InternalModelsGetRequest {
  projectId?: string;
}

export interface InternalModelsIdGetRequest {
  id: string;
}

export interface InternalSessionsGetRequest {
  orchestra?: string;
  region?: string;
  consoleProjectId?: string;
  auraInstanceId?: string;
  includeDeleted?: boolean;
  pageSize?: number;
  currentPage?: number;
  startDate?: string;
  endDate?: string;
}

export interface InternalSessionsSessionIdGetRequest {
  sessionId: string;
}

/**
 *
 */
export class MtlsRequiredApi extends runtime.BaseAPI {
  /**
   * Lists model summaries from the metadata database, optionally filtered by console project. Omitting the model metadata such as graphSchema and modelType.
   * List models
   */
  async internalModelsGetRaw(
    requestParameters: InternalModelsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InternalModelsGet200Response>> {
    const queryParameters: any = {};

    if (requestParameters['projectId'] != null) {
      queryParameters['project_id'] = requestParameters['projectId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/models`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      InternalModelsGet200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists model summaries from the metadata database, optionally filtered by console project. Omitting the model metadata such as graphSchema and modelType.
   * List models
   */
  async internalModelsGet(
    requestParameters: InternalModelsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InternalModelsGet200Response> {
    const response = await this.internalModelsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns a single model from the metadata database, including the model_type, runtime_origin, graph_schema, train_config and model_info metadata.
   * Get model by ID
   */
  async internalModelsIdGetRaw(
    requestParameters: InternalModelsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InternalModelsIdGet200Response>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling internalModelsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/models/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      InternalModelsIdGet200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns a single model from the metadata database, including the model_type, runtime_origin, graph_schema, train_config and model_info metadata.
   * Get model by ID
   */
  async internalModelsIdGet(
    requestParameters: InternalModelsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InternalModelsIdGet200Response> {
    const response = await this.internalModelsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Lists summaries for GDS sessions with optional filtering. Only returns metadata without looking up custom resources.
   * List session summaries
   */
  async internalSessionsGetRaw(
    requestParameters: InternalSessionsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InternalSessionsGet200Response>> {
    const queryParameters: any = {};

    if (requestParameters['orchestra'] != null) {
      queryParameters['orchestra'] = requestParameters['orchestra'];
    }

    if (requestParameters['region'] != null) {
      queryParameters['region'] = requestParameters['region'];
    }

    if (requestParameters['consoleProjectId'] != null) {
      queryParameters['console_project_id'] =
        requestParameters['consoleProjectId'];
    }

    if (requestParameters['auraInstanceId'] != null) {
      queryParameters['aura_instance_id'] = requestParameters['auraInstanceId'];
    }

    if (requestParameters['includeDeleted'] != null) {
      queryParameters['include_deleted'] = requestParameters['includeDeleted'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['currentPage'] != null) {
      queryParameters['current_page'] = requestParameters['currentPage'];
    }

    if (requestParameters['startDate'] != null) {
      queryParameters['start_date'] = requestParameters['startDate'];
    }

    if (requestParameters['endDate'] != null) {
      queryParameters['end_date'] = requestParameters['endDate'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/sessions`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      InternalSessionsGet200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Lists summaries for GDS sessions with optional filtering. Only returns metadata without looking up custom resources.
   * List session summaries
   */
  async internalSessionsGet(
    requestParameters: InternalSessionsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InternalSessionsGet200Response> {
    const response = await this.internalSessionsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns session metadata for the given sessionId. If the session is not deleted, also fetches and returns the ComputeSession CR details from orchestra.
   * Get a session by ID
   */
  async internalSessionsSessionIdGetRaw(
    requestParameters: InternalSessionsSessionIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InternalSessionsSessionIdGet200Response>> {
    if (requestParameters['sessionId'] == null) {
      throw new runtime.RequiredError(
        'sessionId',
        'Required parameter "sessionId" was null or undefined when calling internalSessionsSessionIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/sessions/{sessionId}`;
    urlPath = urlPath.replace(
      `{${'sessionId'}}`,
      encodeURIComponent(String(requestParameters['sessionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      InternalSessionsSessionIdGet200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns session metadata for the given sessionId. If the session is not deleted, also fetches and returns the ComputeSession CR details from orchestra.
   * Get a session by ID
   */
  async internalSessionsSessionIdGet(
    requestParameters: InternalSessionsSessionIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InternalSessionsSessionIdGet200Response> {
    const response = await this.internalSessionsSessionIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
